import { useState } from "react";
import { Link } from "react-router-dom";
import { LogOut, Inbox, Images, CalendarRange, BookOpen, Lock } from "lucide-react";
import AdminEnquiries from "./AdminEnquiries";
import AdminPortfolio from "./AdminPortfolio";
import AdminAvailability from "./AdminAvailability";
import AdminJournal from "./AdminJournal";
import AdminGalleries from "./AdminGalleries";

const TABS = [
  { id: "enquiries", label: "Enquiries", icon: Inbox, Component: AdminEnquiries },
  { id: "portfolio", label: "Portfolio", icon: Images, Component: AdminPortfolio },
  { id: "journal", label: "Journal", icon: BookOpen, Component: AdminJournal },
  { id: "galleries", label: "Clients", icon: Lock, Component: AdminGalleries },
  { id: "availability", label: "Availability", icon: CalendarRange, Component: AdminAvailability },
];

export default function AdminShell({ admin, onLogout }) {
  const [tab, setTab] = useState("enquiries");
  const { Component } = TABS.find((t) => t.id === tab);

  return (
    <div className="min-h-screen bg-[#0D0D10]" data-testid="admin-dashboard">
      <header className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex items-center justify-between gap-6">
          <div>
            <p className="text-[10px] font-mono tracking-[0.25em] uppercase text-stone-500">Private Atelier</p>
            <h1 className="font-serif text-2xl text-ivory">
              Studio <span className="italic text-champagne">Dashboard</span>
            </h1>
          </div>
          <div className="flex items-center gap-3">
            <span data-testid="admin-user-email" className="hidden sm:block text-[10px] font-mono tracking-[0.2em] uppercase text-stone-500">{admin.email}</span>
            <Link to="/" data-testid="admin-view-site" className="hidden sm:block border border-white/15 px-4 py-3 text-[10px] font-mono tracking-[0.2em] uppercase text-stone-300 hover:border-champagne hover:text-champagne transition-colors">
              View Site
            </Link>
            <button data-testid="admin-logout-button" onClick={onLogout} className="inline-flex items-center gap-2 border border-white/15 px-4 py-3 text-[10px] font-mono tracking-[0.2em] uppercase text-stone-300 hover:border-terracotta hover:text-terracotta transition-colors">
              <LogOut size={13} /> Sign Out
            </button>
          </div>
        </div>
        <nav className="max-w-7xl mx-auto px-6 lg:px-10 flex gap-1" data-testid="admin-tabs">
          {TABS.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              data-testid={`admin-tab-${id}`}
              onClick={() => setTab(id)}
              className={`inline-flex items-center gap-2 px-5 py-3 text-[10px] font-mono tracking-[0.2em] uppercase border-b-2 transition-colors ${
                tab === id ? "border-champagne text-champagne" : "border-transparent text-stone-500 hover:text-stone-300"
              }`}
            >
              <Icon size={13} /> {label}
            </button>
          ))}
        </nav>
      </header>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
        <Component onLogout={onLogout} />
      </div>
    </div>
  );
}
